/**
 * @generated SignedSource<<2af438ebe8cfb4cc4e600dd35cb7c14a>>
 * @relayHash 78d5ba22f24ab81e6d99a7404331b9e8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/579.0.0-2026-09-30T11:46:05.781Z/headerRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerRootQuery$variables = {
  fetchRegionalInfo: boolean;
  fetchTrackingGdprInfo?: boolean | null;
  fetchUserRecentHistoryItem?: boolean | null;
  hasTradeUserId: boolean;
  hasUserId: boolean;
  isClient: boolean;
  localRecentHistoryItemIds?: ReadonlyArray<string | null> | null;
  previewKey?: string | null;
  userCountryCode?: string | null;
  userId: string;
  userIds: ReadonlyArray<string | null>;
  variantId?: string | null;
  zipCode: string;
};
export type headerRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"Header_viewer">;
  };
};
export type headerRootQuery = {
  response: headerRootQuery$data;
  variables: headerRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "fetchTrackingGdprInfo"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUserRecentHistoryItem"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v6 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "localRecentHistoryItemIds"
},
v7 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "previewKey"
},
v8 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "variantId"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zipCode"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "path",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLinkable",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v15/*:: as any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v19 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    (v20/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVip",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnly",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileStatus",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            (v13/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v25/*:: as any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Summary",
  "kind": "LinkedField",
  "name": "conversationSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unread",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadActiveOffers",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v34 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "headerRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v7/*:: as any*/),
      (v11/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v5/*:: as any*/),
      (v0/*:: as any*/),
      (v12/*:: as any*/),
      (v8/*:: as any*/),
      (v6/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "headerRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CartTotals",
            "kind": "LinkedField",
            "name": "userCartTotals",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "savedItemsTotal",
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "isPopularSearchesEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "POPULAR_SEARCHES"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"POPULAR_SEARCHES\")"
          },
          {
            "alias": "activeOfferNavFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "activeOfferNav"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"activeOfferNav\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "rootId",
                "variableName": "previewKey"
              },
              {
                "kind": "Variable",
                "name": "variantId",
                "variableName": "variantId"
              }
            ],
            "concreteType": "Navigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NavigationModule",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v14/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isHighlighted",
                    "storageKey": null
                  },
                  (v16/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavigationTopLevel",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v14/*:: as any*/),
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "column",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NavigationItem",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v14/*:: as any*/),
                          (v13/*:: as any*/),
                          (v16/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "imageLinkData",
                    "plural": false,
                    "selections": (v15/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageTitlePrimary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageTitleSecondary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageHeight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageWidth",
                    "storageKey": null
                  },
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": null
          },
          (v13/*:: as any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "relayIsClient",
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Header_viewer$defer$userTracking_viewer",
                "selections": [
                  {
                    "condition": "hasUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userId"
                          }
                        ],
                        "concreteType": "TransactionsCounter",
                        "kind": "LinkedField",
                        "name": "transactionsCounter",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "submittedTransactions",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "submitted",
                            "storageKey": null
                          },
                          {
                            "alias": "confirmedTransactions",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "confirmed",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "fetchTrackingGdprInfo",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "gdprDisplayInfo",
                        "kind": "LinkedField",
                        "name": "gdprDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              (v18/*:: as any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "isGdprApplicable",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                  }
                ],
                "concreteType": "PortfoliosConnection",
                "kind": "LinkedField",
                "name": "portfolios",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 0
                              }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalResults",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "items(first:0)"
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v19/*:: as any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v21/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "Header_viewer$defer$userTracking_user",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "verifiedTradeStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserExistsMetadataType",
                        "kind": "LinkedField",
                        "name": "authMetadata",
                        "plural": false,
                        "selections": [
                          (v24/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPassword",
                            "storageKey": null
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          (v25/*:: as any*/),
                          (v26/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailMd5",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailSha256",
                            "storageKey": null
                          },
                          (v27/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v21/*:: as any*/),
                      (v28/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalMessagesToDealers",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          (v28/*:: as any*/),
                          (v29/*:: as any*/),
                          (v30/*:: as any*/),
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "campaignName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "buyerDisplayable",
                            "storageKey": null
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressBook",
                        "kind": "LinkedField",
                        "name": "addressBook",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "personalAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "line1",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "line2",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "city",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayState",
                                "storageKey": null
                              },
                              (v26/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "country",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "phoneNumber",
                                "storageKey": null
                              },
                              (v13/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isClient",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v23/*:: as any*/),
                      (v31/*:: as any*/),
                      (v22/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserExistsMetadataType",
                        "kind": "LinkedField",
                        "name": "authMetadata",
                        "plural": false,
                        "selections": [
                          (v24/*:: as any*/),
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "AccountNav_user$defer$AccountNavContent_user",
                        "selections": [
                          (v31/*:: as any*/),
                          (v32/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "ethereumWalletAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "address",
                                "storageKey": null
                              },
                              (v13/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "AccountNav_user$defer$AccountNavTrigger_user",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v27/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*:: as any*/),
                          {
                            "condition": "hasTradeUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "kind": "LinkedField",
                                "name": "tradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentYearPoints",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "kind": "LinkedField",
                                    "name": "currentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "kind": "LinkedField",
                                        "name": "programInfo",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "displayName",
                                            "storageKey": null
                                          },
                                          (v13/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "hasTradeUserId",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "AccountNav_user$defer$TradeAccountNavContent_user",
                            "selections": [
                              (v28/*:: as any*/),
                              (v23/*:: as any*/),
                              (v32/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeFirmType",
                                "kind": "LinkedField",
                                "name": "tradeFirm",
                                "plural": false,
                                "selections": [
                                  (v28/*:: as any*/),
                                  (v29/*:: as any*/),
                                  (v30/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TradeFirmPublicProfileType",
                                    "kind": "LinkedField",
                                    "name": "publicProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "urlLabel",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TradeFirmMemberType",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "publicProfileManager",
                                        "storageKey": null
                                      },
                                      (v13/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "SearchBar_user$defer$getRecentHistory_user",
                        "selections": [
                          {
                            "condition": "fetchUserRecentHistoryItem",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v33/*:: as any*/),
                                "concreteType": "RecentHistoryItemsConnection",
                                "kind": "LinkedField",
                                "name": "recentHistoryItems",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RecentHistoryItemsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contemporaryTrackingString",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "size",
                                                "value": "small"
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "firstPhotoWebPath",
                                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pdpURL",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "title",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "browseUrl",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "categoryCode",
                                            "storageKey": null
                                          },
                                          (v28/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "categoryPath",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ecommerceTrackingParams",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Seller",
                                            "kind": "LinkedField",
                                            "name": "seller",
                                            "plural": false,
                                            "selections": [
                                              (v28/*:: as any*/),
                                              (v13/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v13/*:: as any*/),
                                          (v17/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cursor",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endCursor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasNextPage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v33/*:: as any*/),
                                "filters": [
                                  "excludeItemPks"
                                ],
                                "handle": "connection",
                                "key": "getRecentHistory_recentHistoryItems",
                                "kind": "LinkedHandle",
                                "name": "recentHistoryItems"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v18/*:: as any*/),
                  (v19/*:: as any*/),
                  (v34/*:: as any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v34/*:: as any*/)
                    ],
                    "concreteType": "IncomeLevel",
                    "kind": "LinkedField",
                    "name": "incomeLevel",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incomeBracket",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incomePercentile",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v20/*:: as any*/),
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/579.0.0-2026-09-30T11:46:05.781Z/headerRootQuery",
    "metadata": {},
    "name": "headerRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6bd46f8fb49da462c6c25f825ed1b618";

export default node;
